import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Before anything renders: i18next's detector sets the language and
// `document.documentElement.lang`, which the store's ui slice then reads.
import './i18n';
import './styles/tokens.css';
import './styles/base.css';
// Global rather than a module: the table's geometry is one coordinated system
// of custom properties read across component boundaries (frontend.md §2).
import './styles/table.css';
import { App } from './App';
import { installDebugHook } from './debug';

installDebugHook();

const container = document.getElementById('root');
if (container === null) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
